import { Helmet } from 'react-helmet'
import Header from '../../../../Components/Header'
import MainContent from './Maincontent'
const Tax = () => {
  return (
     <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>

      <Helmet>
				<title>Purchase Tax List</title>
			</Helmet>
    <Header />
    <MainContent />
    </div>
  )
}
export default Tax